export function attachHandlers(eventHandlerMap) {
    for (const [event, handler] of eventHandlerMap) {
        event.subscribe((...args) => handler(...args));
    }
}
export const attachValidationOnSubmitClick = (submitButton, formElement, fieldsWithValidation) => {
    attachHandlers([
        [
            submitButton.onClick$,
            (event) => {
                event.preventDefault();
                validateAndSubmitForm(fieldsWithValidation, submitButton, formElement);
            }
        ]
    ]);
};
const validateAndSubmitForm = async (fieldsWithValidation, submitButton, form) => {
    if (submitButton.isLoading) {
        return;
    }
    submitButton.isLoading = true;
    const isFormInvalid = (await Promise.all(fieldsWithValidation.map((field) => field.validate()))).some((isValid) => isValid === false);
    if (isFormInvalid) {
        submitButton.isLoading = false;
        return;
    }
    // Using requestSubmit() instead of submit(), so that submit events fire first and we can attach listeners that will trigger before form is submitted
    form.requestSubmit();
};
